import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const HorizontalArrowLeftContainer = styled.div<{
  vertical: boolean;
  hasLeftButton: boolean;
}>`
  background: rgba(0, 0, 0, 0.8);
  border-radius: ${Screen.widthRatio * 18}px;
  height: ${(props) => (props?.vertical ? 299 : 198) * Screen.widthRatio}px;
  left: ${(props) => Screen.widthRatio * (props.hasLeftButton ? 140 : 4)}px;
  line-height: ${Screen.widthRatio * 360}px;
  opacity: 0;
  padding-left: ${Screen.widthRatio * 29}px;
  position: relative;
  top: ${(props) => (props?.vertical ? -295 : -193) * Screen.widthRatio}px;
  width: ${Screen.widthRatio * 83}px;
  &:hover {
    opacity: 1;
  }
  & > svg {
    left: ${Screen.widthRatio * 27}px;
    position: absolute;
    top: ${(props) => (props.vertical ? 115 : 64) * Screen.widthRatio}px;
  }
`;

export default withAnimation(HorizontalArrowLeftContainer);
